import type { TypedMyBrandFeature } from './-MyBrandFeature';
import RawMyBrandFeature from './MyBrandFeature.vue';
export * from './-MyBrandFeature';
export const MyBrandFeature = RawMyBrandFeature as typeof TypedMyBrandFeature;
